const comp_wide_sliders = document.querySelectorAll(".comp-wide-slider") ?? null;

//% If there are any wide sliders on the current page
if (comp_wide_sliders.length) {

  //% Loop through each wide slider component and initialize a swiper instance from it
  comp_wide_sliders.forEach( component => {
    const swiperEl = component.querySelector("swiper-container");
    const nav_prev = component.querySelector(".btn.prev");
    const nav_next = component.querySelector(".btn.next");
    const pagination = component.querySelector(".pagination");

    swiper_init(swiperEl, {
      navigation: {
        prevEl: nav_prev,
        nextEl: nav_next
      },
      pagination: {
        el: pagination,
        type: 'fraction',
        formatFractionCurrent: (currentIndex) => '0' + currentIndex,
        formatFractionTotal: (total) => '0' + total,
      },
      loop: true,
      spaceBetween: 20,
      grabCursor: true
    });

  })


}